module.exports = __webpack_public_path__ + "img/logo.093a9512.png";